import { Category } from "./category";

export class Tag {
  name: string;
  order?: number;

  posts?: boolean;
  categories?: Category[];
  products?: boolean;
  badge_notification?: boolean;

  users_default_post?: boolean;
  can_users_use?: boolean;

  posts_exists?: boolean;

  private?: boolean;
  is_system?: boolean;
  image?: string;
  title?: string;
  short_desc?: string;

  can_post?: boolean;

  id?: number;
  default_home?: boolean;
  to_user_products?: boolean;
  only_bought?: boolean;
  type?: 'favorite_products' | 'default' | 'regular' | 'user_products_only_bought' | 'user_products'
};
